import React from 'react';

import { RCChip, RCPopover } from '@reverbdotcom/cadence/components';
import { SearchRemixer_FacetGroupFieldsFragment } from '@reverbdotcom/commons/src/gql/graphql';
import { FACET_MAPPING, isSomethingSelected } from './facet';

interface IProps {
  facetGroup: SearchRemixer_FacetGroupFieldsFragment;
  loading?: boolean;
}

export function FacetGroup({ facetGroup, loading = false }: IProps) {
  const [popoverIsOpen, openPopover] = React.useState(false);

  const FacetComponent = FACET_MAPPING[facetGroup.widgetType];
  if (!FacetComponent || !facetGroup.facets) return null;

  const selectedOptions = facetGroup.facets.filter(f => isSomethingSelected(f, true));

  // TODO: this should be handled in search-remixer by setting facetGroup.displayName
  // conditionally on if any options are selected
  const labelTitle = selectedOptions.length === 1 ? selectedOptions[0].displayName : facetGroup.displayName;
  let conditionTitle = null;
  if (facetGroup.key === 'condition_slugs') {
    conditionTitle = facetGroup.facets[0].displayName;
  }
  let priceTitle = null;
  if (facetGroup.key === 'price') {
    priceTitle = facetGroup.displayName;
  }

  return (
    <RCPopover
      isOpen={popoverIsOpen}
      onDismiss={() => openPopover(false)}
      position="bottom-start"
      loading={loading}
      trapFocus
      anchor={
        <RCChip
          selected={selectedOptions.length > 0}
          onClick={() => openPopover(!popoverIsOpen)}
          loading={loading}
          data-testid="facet-group"
        >
          {conditionTitle || priceTitle || labelTitle}
        </RCChip>
      }
    >
      <FacetComponent facetGroup={facetGroup} />
    </RCPopover>
  );
}
